// extracted by mini-css-extract-plugin
module.exports = {"sij1mgf":"sij1mgf","vgugp9j":"vgugp9j","slide":"slide","image-container":"image-container","m1tn1981":"m1tn1981","t15bq72y":"t15bq72y","a1coiana":"a1coiana"};